export const EditIconButton = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#EFF2F8" />
      <path
        d="M13 8.33223L15.6666 10.9989M6.66663 17.3322H9.33329L16.3333 10.3322C16.6869 9.97861 16.8856 9.499 16.8856 8.9989C16.8856 8.4988 16.6869 8.01919 16.3333 7.66557C15.9797 7.31194 15.5001 7.11328 15 7.11328C14.4999 7.11328 14.0202 7.31194 13.6666 7.66557L6.66663 14.6656V17.3322Z"
        stroke="#222530"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
